import './technical-details.scss';

import Swiper from 'swiper';
import { Pagination, Navigation, A11y, Thumbs } from 'swiper/modules';
import SlimSelect from 'slim-select';
import AjaxLoad from './../../utilities/js/ajax-load';
import { createElementFromHTML, tryParseJSON } from '../../utilities/js/helper';

require('../../assets/images/light_wood.jpeg');
require('../../assets/images/dark_wood.jpeg');

class TechnicalDetails {
    constructor ($element) {
        this.$technicalDetailsContainer = $element;
        this.$technicalDetailsSlider = this.$technicalDetailsContainer.querySelector('[data-technical-details-slider="slider"]');
        this.$slides = this.$technicalDetailsSlider?.querySelectorAll('[data-technical-details-slider="slide"]');
        this.$technicalDetailsSliderThumbs = this.$technicalDetailsContainer.querySelector('[data-technical-details-slider-thumbs="slider"]');
        this.$thumbSlides = this.$technicalDetailsSliderThumbs?.querySelectorAll('[data-technical-details-slider-thumbs="slide"]');
        this.slider = null;
        this.sliderThumbs = null;
        this.$selector = this.$technicalDetailsContainer.querySelector('[data-select]');
        this.$imagesTarget = this.$technicalDetailsContainer.querySelector('[data-technical-details="images"]');
        this.$attributesTarget = this.$technicalDetailsContainer.querySelector('[data-technical-details="attributes"]');

        this.$slidePrev = this.$technicalDetailsContainer.querySelector('.slider-controls__prev');
        this.$slideNext = this.$technicalDetailsContainer.querySelector('.slider-controls__next');
        this.$pagination = this.$technicalDetailsContainer.querySelector('.technical-details__slider-pagination');
    }

    initialize () {
        if (this.$slides) {
            if (this.$slides.length > 1) {
                this.initSlider();
                this.resizeSlider();
            }
        }

        if (this.$selector) {
            this.initSelector();
        }
    }

    initSelector () {
        this.selectElement = new SlimSelect({
            select: this.$selector,
            showSearch: false,
            showContent: 'down',
            onChange: (info) => {
                const path = info?.data?.path || info?.option?.dataset?.path || info?.value || info;
                if (path) {
                    this.$attributesTarget.classList.add('is--loading');
                    this.$imagesTarget?.classList.add('is--loading');

                    this.load(path, () => {
                        this.$attributesTarget.classList.remove('is--loading');
                        this.$imagesTarget?.classList.remove('is--loading');
                    });
                }
            }
        });
    }

    load (url, callback) {
        let result = {};

        if (url) {
            new AjaxLoad(encodeURI(url), { // eslint-disable-line
                requestMethod: 'GET',
                onSuccess: (resultText) => {
                    const results = tryParseJSON(resultText);

                    if (results.images && results.attributes) {
                        this.setNewAttributes(createElementFromHTML(results.attributes));
                        this.setNewImages(createElementFromHTML(results.images));
                        this.reinitGallery();
                    }

                    if (typeof callback === 'function') {
                        result = {
                            success: true
                        };
                        callback(result);
                    }
                },
                onError: () => {
                    if (typeof callback === 'function') {
                        // eslint-disable-next-line node/no-callback-literal
                        result = {
                            success: false
                        };
                        callback(result);
                    }
                }
            });
        } else {
            if (typeof callback === 'function') {
                // eslint-disable-next-line node/no-callback-literal
                result = {
                    success: false
                };
                callback(result);
            }
        }
    }

    setNewImages ($images) {
        this.destroySlider();

        if (this.$imagesTarget) {
            this.$imagesTarget.innerHTML = '';

            const images = Array.isArray($images) ? $images : [$images];
            images.forEach((image) => {
                if (image) {
                    this.$imagesTarget.appendChild(image);
                }
            });
        }

        this.initSlider();
    }

    reinitGallery () {
        const $overlayGallery = this.$imagesTarget.querySelector('[data-gallery]');

        if ($overlayGallery) {
            import('../../components/overlay-gallery/overlay-gallery').then(({ OverlayGallery }) => {
                const $overlay = new OverlayGallery($overlayGallery);
                $overlay.initialize();
            });
        }
    }

    setNewAttributes ($attributes) {
        this.$attributesTarget.innerHTML = '';

        const attributes = Array.isArray($attributes) ? $attributes : [$attributes];
        attributes.forEach((attribute) => {
            if (attribute) {
                this.$attributesTarget.appendChild(attribute);
            }
        });

        this.$attributesTarget.classList.remove('is--loading');
    }

    initSlider () {
        this.$technicalDetailsSlider = this.$technicalDetailsContainer.querySelector('[data-technical-details-slider="slider"]');
        this.$slides = this.$technicalDetailsSlider?.querySelectorAll('[data-technical-details-slider="slide"]');
        this.$technicalDetailsSliderThumbs = this.$technicalDetailsContainer.querySelector('[data-technical-details-slider-thumbs="slider"]');
        this.$thumbSlides = this.$technicalDetailsSliderThumbs?.querySelectorAll('[data-technical-details-slider-thumbs="slide"]');
        this.$slidePrev = this.$technicalDetailsContainer.querySelector('.slider-controls__prev');
        this.$slideNext = this.$technicalDetailsContainer.querySelector('.slider-controls__next');
        this.$pagination = this.$technicalDetailsContainer.querySelector('.technical-details__slider-pagination');

        this.sliderThumbs = new Swiper(this.$technicalDetailsSliderThumbs, {
            modules: [Pagination, A11y, Thumbs],
            slidesPerView: 'auto',
            freeMode: true,
            speed: 500,
            slideClass: 'technical-details__slider-thumbs-item',
            wrapperClass: 'technical-details__slider-thumbs-items',
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    direction: 'vertical'
                }
            }
        });

        this.slider = new Swiper(this.$technicalDetailsSlider, {
            modules: [Pagination, Navigation, A11y, Thumbs],
            slidesPerView: 1,
            speed: 500,
            spaceBetween: 10,
            slideClass: 'technical-details__slider-item',
            wrapperClass: 'technical-details__slider-items',
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: this.$slideNext,
                prevEl: this.$slidePrev,
                disabledClass: 'slider-controls__disabled'
            },
            thumbs: {
                swiper: this.sliderThumbs
            },
            breakpoints: {
                768: {
                    direction: 'vertical',
                    spaceBetween: 0
                }
            },
            on: {
                slideChangeTransitionStart: () => {
                    const $progressBar = this.$technicalDetailsContainer.querySelector('.slider-pagination');
                    $progressBar.classList.add('is--active');
                },
                slideChangeTransitionEnd: () => {
                    const $progressBar = this.$technicalDetailsContainer.querySelector('.slider-pagination');
                    $progressBar.classList.remove('is--active');
                }
            }
        });

        if (window.innerWidth >= 1024) {
            this.setSliderHeight();
        }
    }

    setSliderHeight () {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1024) {
            for (let i = 0; i < this.$slides.length; i++) {
                const $slide = this.$slides[i];
                const $slideImage = $slide.querySelector('.technical-details__slider-item-image');
                const slideImageHeight = $slideImage.offsetHeight;
                const slidePadding = parseInt(window.getComputedStyle($slide).paddingTop.replace('px', '')) + parseInt(window.getComputedStyle($slide).paddingBottom.replace('px', ''));
                const slideHeight = slideImageHeight + slidePadding;
                this.$technicalDetailsSlider.style.maxHeight = slideHeight + 'px';
            }

            for (let i = 0; i < this.$thumbSlides.length; i++) {
                const $slide = this.$thumbSlides[i];
                const $slideImage = $slide.querySelector('.technical-details__slider-thumbs-item-image');
                const slideImageHeight = $slideImage.offsetHeight;
                const slidePadding = parseInt(window.getComputedStyle($slide).paddingTop.replace('px', '')) + parseInt(window.getComputedStyle($slide).paddingBottom.replace('px', ''));
                const slideHeight = slideImageHeight + slidePadding;
                $slide.style.maxHeight = slideHeight + 'px';
            }
        } else {
            this.$technicalDetailsSlider.style.maxHeight = 'none';
        }
    }

    resizeSlider () {
        window.resizeHandler.customFunctions.push(() => {
            const windowWidth = window.innerWidth;
            if (windowWidth >= 1024) {
                this.setSliderHeight();
            } else {
                this.$technicalDetailsSlider.style.maxHeight = '';

                for (let i = 0; i < this.$thumbSlides.length; i++) {
                    this.$thumbSlides[i].style.maxHeight = '';
                }
            }
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { TechnicalDetails };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $technicalDetails = $context.querySelectorAll('[data-technical-details="root"]');
        if ($technicalDetails.length > 0) {
            $technicalDetails.forEach((technicalDetails) => {
                const $technicalDetails = new TechnicalDetails(technicalDetails);
                $technicalDetails.initialize();
            });
        }
    }
});
